module.exports = __webpack_public_path__ + "img/facebook@2x.dd36c81b.png";